import { Expose } from 'class-transformer'

export class TrafficByUserType {
  @Expose({ name: 'sourceName' }) name: number

  @Expose({ name: 'count' }) value: number
}
